import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ShieldIcon, BookOpenIcon } from 'lucide-react';
import { Container } from '../../ui/Container';
import { Button } from '../../ui/Button';
export function SupportingFamilies() {
  return <section className="relative py-20 md:py-28 overflow-hidden bg-sand-50/60" data-id="element-674" data-mp="6x3f4rnoqobn">
      <Container data-id="element-675" data-mp="6z6hmb60y9x9">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-676" data-mp="kwuyz90vuyxk">
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} className="lg:col-span-6 relative" data-id="element-677" data-mp="kurz7x9xhrfn">
            <div className="relative aspect-square" data-id="element-678" data-mp="zn27avx6f1kj">
              <div className="absolute inset-0 rounded-3xl overflow-hidden ring-1 ring-sand-300/40 shadow-card" data-id="element-679" data-mp="pckyss4myjra">
                <img src="https://cdn.magicpatterns.com/uploads/w61trt4PHZuMs5cy1RMxTR/ForParents1.jpg" alt="Muslim family laughing together during a picnic in a sunlit park" className="w-full h-full object-cover" data-id="element-680" data-mp="uaw9t66o30b3" />
              </div>
            </div>
          </motion.div>

          <div className="lg:col-span-6" data-id="element-681" data-mp="18axaakj0s5q1">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sage-100 text-forest-700 text-[11px] font-semibold tracking-[0.14em] uppercase" data-id="element-682" data-mp="1da0gw9enek04">
              For Parents
            </span>
            <h2 className="font-display text-3xl md:text-4xl lg:text-[2.75rem] leading-tight text-ink-900 mt-5" data-id="element-683" data-mp="1m2tyidhkhvh5">
              Supporting Families
              <br data-id="element-684" data-mp="1qzkd0wdq4j0g" />
              Beyond The Classroom
            </h2>

            <div className="mt-7 flex flex-wrap gap-3" data-id="element-685" data-mp="1w1jhk9l79lyz">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage-100 text-forest-700 text-sm font-medium" data-id="element-686" data-mp="3s3mwrhfk59pp">
                <ShieldIcon size={14} strokeWidth={1.6} data-id="element-687" data-mp="3n5uw9z0ukf9w" />
                Membership
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sand-100 text-sand-500 text-sm font-medium" data-id="element-688" data-mp="5p3gtgaxpmh4">
                <BookOpenIcon size={14} strokeWidth={1.6} data-id="element-689" data-mp="vikdsozp0k1" />
                Resources
              </span>
            </div>

            <p className="mt-6 text-ink-700 leading-relaxed" data-id="element-690" data-mp="anoi7j1xac75">
              Strong families grow stronger together.
            </p>

            <ul className="mt-5 space-y-3 text-ink-700" data-id="element-691" data-mp="om4m728eholl">
              <li className="flex gap-3" data-id="element-692" data-mp="jo352mujbzcr">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-forest-700 flex-shrink-0" data-id="element-693" data-mp="jpea0pzpvd5g" />
                <span data-id="element-694" data-mp="2qfltg4smcnft">
                  The Parent Membership is a balanced family support system.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-695" data-mp="2lhk8tffjog28">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-forest-700 flex-shrink-0" data-id="element-696" data-mp="10x5eqkxqgqqr" />
                <span data-id="element-697" data-mp="15x1j4lacek6u">Access to guidance without confusion.</span>
              </li>
              <li className="flex gap-3" data-id="element-698" data-mp="r7vmn52w382n">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-forest-700 flex-shrink-0" data-id="element-699" data-mp="r6ucd2tp6plz" />
                <span data-id="element-700" data-mp="w5dzh6k127fx">A safe place to ask, share, and learn.</span>
              </li>
              <li className="flex gap-3" data-id="element-701" data-mp="i6nz9i1wvrnc">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-forest-700 flex-shrink-0" data-id="element-702" data-mp="i90hlwbl040x" />
                <span data-id="element-703" data-mp="n7bru85sggjo">Tools and resources for engagement.</span>
              </li>
              <li className="flex gap-3" data-id="element-704" data-mp="8a1esudhz2lu">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-forest-700 flex-shrink-0" data-id="element-705" data-mp="d7unbu29w8pa" />
                <span data-id="element-706" data-mp="d9nsf4x8mkv6">
                  A weekly space to find rest, plan clearly, and walk with
                  clarity and confidence.
                </span>
              </li>
            </ul>

            <div className="mt-8" data-id="element-707" data-mp="27jhr46357jht">
              <Link to="/en/parents" data-id="element-708" data-mp="7jw2yh3rb4d6">
                <Button variant="primary" data-id="element-709" data-mp="7ita43mvirum">Discover More</Button>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}